import { createFileRoute } from "@tanstack/react-router";
import AdminPage from "lib/components/admin/builders/AdminPage";
import BuilderHeader from "lib/components/builders/BuilderHeader";
import type { PlanPickerOptions } from "lib/components/demo/PlanPicker";
import PlanPicker from "lib/components/demo/PlanPicker";
import { getAllOptionCatalogsMigrationURL } from "lib/endpointHelpers";
import { deleteWithTimeout, postWithTimeout, getWithTimeout } from "lib/utils/fetchAuthHelpers";
import { useState } from "react";
import Button from "ui/buttons/Button";
import InputGroupNumber from "ui/forms/InputGroupNumber";
import useAppContext from "ui/hooks/useAppContext";
import withAuthentication from "../../../components/withAuthentication";
import styles from "./index.module.scss";
import { MigrateOptionsFromDocToCatalog } from "./migrate-options";

const planPickerOptions: PlanPickerOptions = {
  pickLocation: false,
  pickLocationPlan: false,
};

function OptionMigrationDebug() {
  const { setUserNotification } = useAppContext();
  const [builderSyncCount, setBuilderSyncCount] = useState(5);
  const [builderSyncPageIndex, setBuilderSyncPageIndex] = useState(0);

  return (
    <AdminPage currentPage="debug" pageTitle="Option Migration">
      <BuilderHeader header="Option Migration" />
      <div className={styles.adminPageWrapper}>
        <div className={styles.adminControls}>
          <Button
            type="button"
            btnStyle="secondary"
            btnSize="medium"
            onClick={async () => {
              const res = await getWithTimeout(`${getAllOptionCatalogsMigrationURL()}/profile`);
              if (res.ok) {
                const profile = await res.json();
                console.log(profile);
                setUserNotification({
                  messageType: "success",
                  message: "See console for DB data profile details",
                });
              }
            }}
          >
            Get Data Profile
          </Button>
          <Button
            type="button"
            btnStyle="remove"
            btnSize="medium"
            onClick={async () => {
              const res = await deleteWithTimeout(
                `${getAllOptionCatalogsMigrationURL()}/delete-all`,
                undefined,
                30 * 1000,
              );
              if (res.ok) {
                setUserNotification({
                  messageType: "success",
                  message: "Deleting all migrations from DB, this may take some time.",
                });
              }
            }}
          >
            Delete All Migrations (All Builders)
          </Button>
          <InputGroupNumber
            placeholder="Enter number of builders to migrate"
            labelText="Migrate: # of builders"
            inputValue={builderSyncCount}
            onChange={(x) => setBuilderSyncCount(x ?? 0)}
          />
          <InputGroupNumber
            placeholder="Enter index of page to start syncing builders from"
            labelText="Migrate: Page index"
            inputValue={builderSyncPageIndex}
            onChange={(x) => setBuilderSyncPageIndex(x ?? 0)}
          />
          <Button
            type="button"
            btnStyle="secondary"
            btnSize="medium"
            onClick={async () => {
              const res = await postWithTimeout(
                `${getAllOptionCatalogsMigrationURL()}/migrate-all?batchSize=${builderSyncCount}&page=${builderSyncPageIndex}`,
                undefined,
                30 * 1000,
              );
              if (res.ok) {
                setUserNotification({
                  messageType: "success",
                  message: "Migrating builders in DB, this may take some time.",
                });
              }
            }}
          >
            Migrate Multiple Builders
          </Button>
        </div>
        <PlanPicker className={styles.adminPage} options={planPickerOptions}>
          <MigrateOptionsFromDocToCatalog />
        </PlanPicker>
      </div>
    </AdminPage>
  );
}

export const Route = createFileRoute("/debug/option-migration/")({
  component: withAuthentication(OptionMigrationDebug, { superAdmin: true }),
});
